import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-start" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "app__main" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("main", { class: "app__mobile" }, [
  /*#__PURE__*/_createTextVNode("Please use this dapp"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("on desktop")
], -1)

import AppHeader from "@/components/app-header/index.vue";
import AppMenu from "@/components/app-menu/index.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader),
    _createVNode(AppMenu),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("main", _hoisted_4, [
            _createVNode(_component_router_view, { name: "view" })
          ]),
          _hoisted_5
        ])
      ])
    ]),
    _createVNode(_component_router_view, { name: "modal" })
  ], 64))
}
}

})